import '../styles/SingleListing.css';
import { projects } from '../assets/projects';
import { useParams, Link } from 'react-router';
import { FaCheckCircle } from 'react-icons/fa';


const PropertyListing = () => {
  const { productId } = useParams();
  const product = projects.find(p => p.id === parseInt(productId));


  const galleryImages = [product.imageUrl1, product.imageUrl2, product.imageUrl3, product.imageUrl4, product.imageUrl5, product.imageUrl6];

  const locations = [...new Set(projects.map(product => product.location))];

  return (
  <>
  <title>Zuri Lands Investment Limited</title>
   <div className="banner">
    <h2>{product.title}</h2>
   </div>

    <div className="container">
      {/* Main Content Column */}
      <div className="main-content">
        {/* YouTube Video */}
      
        <div className="section">
          <div className="video-container">
            {/*}
            <iframe 
              src={product.youtubeUrl}
              title="Project Introduction"
              allowFullScreen
            /> 
            */}
            
            <img 
            src={product.featuredImg}
            alt="Development" 
            className="top-image"
          />

          </div>
        </div>

        {/* Project Introduction */}
        <div className="section">
          <h1>{product.descriptionTitle}</h1>
          <p>
            {product.paragraph1}.
          </p>
        </div>

        {/* Why Invest */}
        <div className="section_why">
          <h2>{product.whyTitle}</h2>
          <ul>
            {product.reasons.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          <h2>{product.pricingTitle }</h2>
          <p>{product.pricing}</p>
          <h2>{product.siteVisit }</h2>
          <p>{product.siteVisitDetails}</p>
          
        </div>

        {/* Amenities */}
        <div className="section">
          <h2>Features</h2>
          <div className="amenities-grid">
            {product.propertyFeatures.map((item, index) => (
              <div key={index} className="amenity-item">
                <FaCheckCircle className="amenity-icon" />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="section">
          <h2>Details</h2>
          <div className="details-body">
            <div className="details-row">
              <div className="details-item">
                <h3>Price:</h3>
                <p>{product.price}</p>
              </div>
              <div className="details-item">
                <h3>Property Size:</h3>
                <p>{product.size}</p>
              </div>
              <div className="details-item">
                <h3>Land Area:</h3>
                <p>{product.landArea}</p>
              </div>
            </div>
            <div className="details-row">
              <div className="details-item">
                <h3>Property Type:</h3>
                <p>{product.propertyType}</p>
              </div>
              <div className="details-item">
                <h3>Property Status:</h3>
                <p>{product.propertyStatus}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Featured Image */}
        <div className="section">
          <img 
            src={product.featuredImg}
            alt="Development" 
            className="featured-image"
          />
        </div>

        {/* Gallery */}
        <div className="section">
          <h2>Project Gallery</h2>
          <div className="gallery-grid">
            {galleryImages.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Gallery ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Sidebar Column */}
      <div className="sidebar">
        {/* Search Section */}
      <div className="section-search">
        <div className="search-section">
          <input
            type="text"
            placeholder="Search listings..."
            className="search_input"
          />
        </div>
       </div> 

        {/* Other Areas */}
        <div className="section-other">
        <div className="other-areas">
          <h3>Properties for sale</h3>
          {locations.map(location => (
            <Link to = {`/locations/${encodeURIComponent(location).replace(/%20/g, '-')}`} className="area-link">{location}</Link>
          ))}
        </div>
        </div>
      </div>

    </div>
  </>
  );
};

export default PropertyListing;